import GenericTabComponent from "../../components/GenericTabComponent";
import About from "./Tabs/About";
import LogoMascot from "./Tabs/LogoMascot";

export default function AsiaRugbyA207s() {
  const content = [
    { label: "विषय", component: <About /> },
    { label: "लोगो एवं मास्कॉट", component: <LogoMascot /> },
  ];
  const pagetitle = "एशिया रग्बी अंडर-20 सेवेन्स चैंपियनशिप 2025",
    desktopBanner = "/img/AsiaRugbyU207s/desktopBanner.jpg",
    // desktopBanner = "/img/model-code-conduct/AsiaRugbyU207s/desktopBanner.jpg",
    mobileBanner = "/img/AsiaRugbyU207s/mobileBanner.jpg";
    // mobileBanner = "/img/model-code-conduct/AsiaRugbyU207s/mobileBanner.jpg";
  return (
    <>
      <GenericTabComponent
        content={content}
        desktopBanner={desktopBanner}
        mobileBanner={mobileBanner}
        pageTitle={pagetitle}
      />
    </>
  );
}
